export default "__VITE_ASSET__EK0OucEn__"